import ActionTypes from '../constants';

const initialState = {
    investigations: {},
    parallelInvestigations: {},
    investigation: {},
    investigationByVehicleReplacement: {}
    // loading: false,
};

const investigationReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETINVESTIGATIONSUCCESS:
            return {
                ...state,
                investigations: action.payload,
            }
        case ActionTypes.GETPARALLELINVESTIGATIONSUCCESS:
            return {
                ...state,
                parallelInvestigations: action.payload,
            }
        case ActionTypes.GETINVESTIGATIONBYIDSUCCESS:
            // action)
            return {
                ...state,
                investigation: action.payload,
            }
        case ActionTypes.GETINVESTIGATIONBYVEHICLEREPLACEMENTIDSUCCESS:
            // action)
            return {
                ...state,
                investigationByVehicleReplacement: action.payload,
            }
        default:
            return state;
    }
}

export default investigationReducer;